import md5 from 'md5'

export function fetch(state = { results: {}, status: {} }, action) {
	switch (action.type) {
		case 'FETCH_QUERIES_START': {
			const { status, results } = state
			const { query } = action
			const statusKey = md5(query)

			status[statusKey] = {
				status: 'pending'
			}

			return {
				results: { ...results },
				status: { ...status }
			}
		}
		case 'FETCH_QUERIES_REJECT': {
			const { status, results } = state
			const { error, query } = action
			const statusKey = md5(query)

			status[statusKey] = {
				status: 'error',
				message: error
			}

			return {
				results: { ...results },
				status: { ...status }
			}
		}
		case 'FETCH_QUERIES_SUCCESS': {

			const { status, results } = state
			const { response, query } = action

			const now = Date.now()

			const statusKey = md5(query)

			status[statusKey] = {
				status: 'success',
				lastRead: now
			}

			results[query] = response.data ? response.data : response

			return {
				results: { ...results },
				status: { ...status }
			}
		}
	}
	return state
}



// WEBPACK FOOTER //
// ./src/store/reducers/fetchReducer.js